import {
  CreditsUsage,
  UsageListItem,
  CreditsManagement,
  CreditManagementCreditType,
} from './creditsManagementTypes';
import {
  CreditsManagementThunk,
  SetCreditUsageListType,
  SET_PAYMENT_COMPANY_CREDITS,
  SetCompanyCreditsActionType,
  CREDITS_MANAGEMENT_SET_CREDIT_TYPES,
  CREDITS_MANAGEMENT_SET_CREDITS_USAGE_LIST,
  creditsManagementSetCreditTypesActionType,
  CREDITS_MANAGEMENT_SET_COMPANY_USAGE_CREDITS,
  CREDITS_MANAGEMENT_SET_COMPANY_MANAGEMENT_CREDITS,
  creditsManagementSetCompanyUsageCreditsActionType,
  creditsManagementSetCompanyManagementCreditsActionType,
  CREDITS_MANAGEMENT_SET_COMPANY_MANAGEMENT_ACTIVE_CREDIT,
  creditsManagementSetCompanyManagementActiveCreditActionType,
} from './creditsManagementActionTypes';
import { startLoaderThunk, stopLoaderThunk } from '../modal/modalActions';
import CreditsManagementApi from '../../API/credits-management/CreditsManagement.api';

export function creditsManagementSetCompanyManagementCreditsAction(
  credits: CreditsManagement[]
): creditsManagementSetCompanyManagementCreditsActionType {
  return {
    type: CREDITS_MANAGEMENT_SET_COMPANY_MANAGEMENT_CREDITS,
    payload: credits,
  };
}

export function creditsManagementSetCreditTypesAction(
  creditTypes: CreditManagementCreditType[]
): creditsManagementSetCreditTypesActionType {
  return {
    type: CREDITS_MANAGEMENT_SET_CREDIT_TYPES,
    payload: creditTypes,
  };
}

export function creditsManagementSetCompanyManagementActiveCreditAction(
  credit: CreditsManagement
): creditsManagementSetCompanyManagementActiveCreditActionType {
  return {
    type: CREDITS_MANAGEMENT_SET_COMPANY_MANAGEMENT_ACTIVE_CREDIT,
    payload: credit,
  };
}

export function creditsManagementSetCompanyUsageCreditsAction(
  credits: CreditsUsage[]
): creditsManagementSetCompanyUsageCreditsActionType {
  return {
    type: CREDITS_MANAGEMENT_SET_COMPANY_USAGE_CREDITS,
    payload: credits,
  };
}

export function creditsManagementSetCreditUsageListAction(
  usageList: UsageListItem[]
): SetCreditUsageListType {
  return {
    type: CREDITS_MANAGEMENT_SET_CREDITS_USAGE_LIST,
    payload: usageList,
  };
}

export function setCompanyCreditsAction(
  credits: CreditsUsage[]
): SetCompanyCreditsActionType {
  return {
    type: SET_PAYMENT_COMPANY_CREDITS,
    payload: credits,
  };
}

export function useFetchManagementCreditsThunk(): CreditsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsManagementApi.getCompanyManagementCredits()
      .then((response) => {
        dispatch(
          creditsManagementSetCompanyManagementCreditsAction(response.data)
        );
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function fetchCreditCompanyBalancesThunk(): CreditsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsManagementApi.getCompanyCreditBalances()
      .then((response) => {
        dispatch(creditsManagementSetCompanyUsageCreditsAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function fetchCompanyCreditUsageListThunk(
  creditBalanceId: number
): CreditsManagementThunk<Promise<void>> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsManagementApi.getCompanyCreditUsageList(creditBalanceId)
      .then((response) => {
        dispatch(creditsManagementSetCreditUsageListAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function creditsManagementFetchCreditTypesThunk(): CreditsManagementThunk<
  Promise<void>
> {
  return async (dispatch, getState) => {
    dispatch(startLoaderThunk()).finally();
    CreditsManagementApi.getCreditTypes()
      .then((response) => {
        dispatch(creditsManagementSetCreditTypesAction(response.data));
      })
      .finally(() => {
        dispatch(stopLoaderThunk());
      });
  };
}

export function FetchCompanyCreditsForPaymentThunk(): CreditsManagementThunk<
  Promise<void>
> {
  return async (dispatch) => {
    CreditsManagementApi.getCompanyCreditBalances().then((response) => {
      dispatch(setCompanyCreditsAction(response.data));
    });
  };
}
